/**
 * The full picker's emoji, by category. Emoji are data, not copy; a
 * category's title is the i18n key `chat:emoji.categories.<id>`.
 * Only fully-qualified single emoji the API's CHAT_EMOJI_PATTERN accepts.
 */
export const EMOJI_CATEGORIES = [
  {
    id: "smileys",
    emojis: [
      "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃", "😉", "😊",
      "😇", "🥰", "😍", "🤩", "😘", "😗", "😚", "😙", "😋", "😛", "😜", "🤪",
      "😝", "🤑", "🤗", "🤭", "🤫", "🤔", "🤐", "🤨", "😐", "😑", "😶", "😏",
      "😒", "🙄", "😬", "😌", "😔", "😪", "🤤", "😴", "😷", "🤒", "🤕", "🤢",
      "🤮", "🥵", "🥶", "😵", "🤯", "🤠", "🥳", "😎", "🤓", "🧐", "😕", "😟",
      "🙁", "😮", "😯", "😲", "😳", "🥺", "😦", "😧", "😨", "😰", "😥", "😢",
      "😭", "😱", "😖", "😣", "😞", "😓", "😩", "😫", "🥱", "😤", "😡", "😠",
    ],
  },
  {
    id: "gestures",
    emojis: [
      "👍", "👎", "👌", "🤌", "✌️", "🤞", "🤟", "🤘", "🤙", "👈", "👉", "👆",
      "👇", "☝️", "👋", "🤚", "🖐️", "✋", "🖖", "👏", "🙌", "👐", "🤲", "🤝",
      "🙏", "✍️", "💪", "🫡", "🫶", "🙋", "🙆", "🙅", "🤷", "🤦", "💁", "🙇",
    ],
  },
  {
    id: "hearts",
    emojis: [
      "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔", "❣️", "💕",
      "💞", "💓", "💗", "💖", "💘", "💝", "💯", "💢", "💥", "💫", "💦", "💨",
    ],
  },
  {
    id: "celebration",
    emojis: [
      "🎉", "🎊", "🎈", "🎁", "🎂", "🍰", "🥂", "🍾", "🏆", "🥇", "🥈", "🥉",
      "🏅", "🎖️", "⭐", "🌟", "✨", "🔥", "⚡", "🌈", "☀️", "🌙", "🎯", "🚀",
    ],
  },
  {
    id: "work",
    emojis: [
      "💼", "📁", "📂", "📅", "📆", "🗓️", "📌", "📍", "📎", "✏️", "📝", "📊",
      "📈", "📉", "💻", "🖥️", "📱", "☎️", "📞", "✉️", "📧", "📢", "🔔", "⏰",
      "⏳", "✅", "☑️", "❌", "❗", "❓", "⚠️", "🔒", "🔑", "💡", "🔍", "🛠️",
    ],
  },
  {
    id: "food",
    emojis: [
      "☕", "🍵", "🧃", "🥤", "🍕", "🍔", "🍟", "🌯", "🥗", "🍣", "🍜", "🍩",
      "🍪", "🍫", "🍿", "🍎", "🍌", "🍉", "🍓", "🥑", "🌶️", "🍞", "🧁", "🍦",
    ],
  },
  {
    id: "nature",
    emojis: [
      "🐶", "🐱", "🐭", "🐰", "🦊", "🐻", "🐼", "🐨", "🦁", "🐯", "🐮", "🐵",
      "🐔", "🐧", "🐦", "🦋", "🐝", "🌸", "🌹", "🌻", "🌴", "🌵", "🍀", "🌍",
    ],
  },
  {
    id: "travel",
    emojis: [
      "🚗", "🚕", "🚌", "🚆", "✈️", "🛫", "🛬", "🚢", "🏠", "🏢", "🏥", "🏖️",
      "⛰️", "🗺️", "🧳", "⛽", "🚦", "🚧", "⚽", "🏀", "🎾", "🏋️", "🚴", "🎮",
    ],
  },
] as const;

export type EmojiCategoryId = (typeof EMOJI_CATEGORIES)[number]["id"];
